import classes from './Footer.module.css'

const Footer = () => {
    return ( 
        <footer className={classes.footer}>

        </footer>
     );
}
 
export default Footer;